import React from "react";

export default function Footer({ t }) {
  return (
    <footer className="w-full bg-white border-t border-zinc-200 py-16 px-6 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-1 bg-brand-navy"></div>
      
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 gap-12 items-start text-sm text-zinc-500">
        {/* Presented By & Copyright */}
        <div className="text-left flex flex-col gap-3">
          <div className="text-brand-navy font-bold text-xs uppercase tracking-[0.15em]">
            {t("footer.presentedBy")}
          </div>
          <div className="text-zinc-400 text-xs">
            &copy; {new Date().getFullYear()} Albertsen Group, LLC. {t("footer.rights")}
          </div>
        </div>
      </div>
    </footer>
  );
}
